import { ErrorLabelProps } from './props';
import styles from './styles.module.scss';
import { ErrorTooltipType } from '@/enums/errorTooltipType';
import useTranslation from 'next-translate/useTranslation';
import ErrorLabelCoin from './Coin';
import { TransTextWithDefault } from '@starsoft/common/components';

export default function ErrorLabel({ error, open, coin }: ErrorLabelProps) {
  const { t } = useTranslation('common');

  if (!error || !open) {
    return null;
  }

  function getError() {
    switch (error) {
      case ErrorTooltipType.OVERVALUED:
        return t('error_overvalued');
      case ErrorTooltipType.UNDERVALUED:
        return t('error_undervalued');
    }
  }

  return (
    <div className={styles.container}>
      <TransTextWithDefault
        text={getError() ?? ''}
        components={{
          coin: <ErrorLabelCoin coin={coin} />,
        }}
      />
    </div>
  );
}
